import { useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Column, FormField, Radio, RadioGroup, Row } from '@tempmee/react';
import { SolidExclamationWarningAlertIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { EducationUtils } from '../../../../../utils/EducationUtils';
import { filterObjectKeys } from '../../../../../utils/Object';
import { useFormContext } from '../../../hooks/useFormContext';

export const PrimaryPracticeField = () => {
  const officeEducation = useSelector((state) => state.user.officeEducation);
  const {
    setValue,
    formState: { errors },
  } = useFormContext();

  const selectedSpecialty = useWatch({ name: 'selectedSpecialty' });

  const items = Object.keys(
    filterObjectKeys(officeEducation?.specialtiesAndProcedures, 'specialty') || {},
  );
  const halfLength = Math.ceil(items.length / 2);
  const firstColumnItems = items.slice(0, halfLength);
  const secondColumnItems = items.slice(halfLength);

  return (
    <FormField
      label="What is your area of primary practice?"
      TrailingComponent={
        errors.selectedSpecialty ? (
          <SolidExclamationWarningAlertIcon width={16} height={16} color={colors.warning['500']} />
        ) : null
      }
    >
      <RadioGroup
        value={selectedSpecialty ?? ''}
        onChange={(value) => setValue('selectedSpecialty', value, { shouldDirty: true })}
      >
        <Row style={{ marginLeft: 40 }} gap={16}>
          <Column gap={5}>
            {firstColumnItems.map((code) => (
              <Radio
                key={code}
                value={code}
                label={EducationUtils.removeSpecialtyPrefix(code)}
              />
            ))}
          </Column>
          <Column gap={5}>
            {secondColumnItems.map((code) => (
              <Radio
                key={code}
                value={code}
                label={EducationUtils.removeSpecialtyPrefix(code)}
              />
            ))}
          </Column>
        </Row>
      </RadioGroup>
    </FormField>
  );
};
